// extracted by mini-css-extract-plugin
export default {"contentContainer":"style_contentContainer__pjLy3","crossContainer":"style_crossContainer__vpKdb","modalBody":"style_modalBody__WGo4H"};